import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
.Overlay {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${colors.baseBg};
  z-index: 2;
}
`
